var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zzjsbmztdxmbllc-all-box"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":require("@/assets/images/serviceGuide/zzjsbmztdxmbllc.png"),"width":"100%","alt":""}})]),_c('div',{staticClass:"text"},[_vm._v(" 医保物价办电话：0512-65795492 ")])])
}]

export { render, staticRenderFns }